import { render, staticRenderFns } from "./dpWallet.vue?vue&type=template&id=9fc2bb6e&scoped=true"
import script from "./dpWallet.vue?vue&type=script&lang=js"
export * from "./dpWallet.vue?vue&type=script&lang=js"
import style0 from "./dpWallet.vue?vue&type=style&index=0&id=9fc2bb6e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc2bb6e",
  null
  
)

export default component.exports